import { render, staticRenderFns } from "./podcasts.vue?vue&type=template&id=79cc1b17"
import script from "./podcasts.vue?vue&type=script&setup=true&lang=ts"
export * from "./podcasts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports